import Header from '../utill/Header'
import Footer from '../utill/Footer'
import Sidebar from '../utill/Sidebar'
import {Button, Card, Form, Table} from "react-bootstrap";
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import Url from "../utill/Url";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import {
    Paper,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    TextField
} from "@mui/material";
import {RootState} from "../../redux/store";
import Pagination from "../utill/Pagination";
import Loading from "../utill/Loading";
import StyledTableCell from "../utill/StyledTableCell"
import dayjs, {Dayjs} from "dayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";

interface HistoryPageCallLog {
    id: number;
    userId: string;
    userName: string;
    ip: string;
    description: string;
    dtm: string;
}

function HistoryPageCallLog() {
    const url = useContext(Url)
    const [data, setData] = useState<HistoryPageCallLog[]>([]);
    const [totalData, setTotalData] = useState();
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [textCurrentPage, setTextCurrentPage] = useState('1');
    const [listSelected, setListSelected] = useState("15");
    const [searchedData, setSearchedData] = useState(["",""]);
    const [startDate, setStartDate] = React.useState<any>(dayjs().startOf('day').locale('ko-KR'));
    const [endDate, setEndDate] = React.useState(dayjs().startOf('day').locale('ko'));
    const [startDtm, setStartDtm] = useState("");
    const [endDtm, setEndDtm] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const user = useSelector((state: RootState) => state.user.value);
    let userId = user.id;
    const auth = useSelector((state: RootState) => state.loginAuth.value);

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-이력 페이지 접속 기록'
        if (auth.MENUAUTH?.HIST0100?.readAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        reissue(userId, url, navigate).then(() => {
            setLoading(true)
            axios.get(url + 'userlocation/view', {
                params:{
                    data: searchedData.join(','),
                    page: currentPage,
                    startDtm: startDtm,
                    endDtm: endDtm,
                    listCnt: listSelected
                },
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                const result = response.data.result
                setLoading(false)
                setData(result.data)
                setTotalData(result.totalData)
                setTotalPages(result.totalPage)
            })
        })
    }, [currentPage, listSelected]);

    useEffect(() => {
        setCurrentPage(1);
        setTextCurrentPage('1');
    }, [listSelected]);

    const handleHistorySubmit = async () => {
        let data = ["",""];
        setLoading(true);
        setCurrentPage(1)
        setTextCurrentPage('1')
        setStartDtm(startDate.format('YYYY-MM-DD 00:00:00'))
        setEndDtm(endDate.format('YYYY-MM-DD 23:59:59'))
        setSearchedData([...data]);
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'userlocation/view', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    data: data.join(','),
                    page: 1,
                    startDtm: startDate.format('YYYY-MM-DD 00:00:00'),
                    endDtm: endDate.format('YYYY-MM-DD 23:59:59'),
                    listCnt: listSelected
                }
            }).then((response) => {
                const result = response.data.result
                setLoading(false)
                setData(result.data)
                setTotalData(result.totalData)
                if (result.totalPage !== 'undefined') {
                    setTotalPages(result.totalPage);
                } else {
                    setTotalPages(1)
                }
            })
        })
    }

    const handleChangeListSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setListSelected(e.target.value);
    }

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        setTextCurrentPage(page.toString());
    };

    const handleCurrentPageText = () => {
        const numericValue = parseInt(textCurrentPage, 10);
        if (!isNaN(numericValue) && numericValue > 0 && numericValue <= totalPages) {
            // 숫자인 경우
            setCurrentPage(numericValue);
        } else if(numericValue >= totalPages){
            alert('총 페이지 보다 높은 수를 입력하실 수 없습니다')
        }else {
            // 숫자가 아닌 경우
            alert("숫자만 입력 가능합니다.");
        }
    };

    const setEndDateChange = (value: Dayjs | null) => {
        if (!value) return;

        if (value.isBefore(startDate)) {
            setStartDate((value.subtract(1, 'day')));
        }
        setEndDate(value);
    };

    return (
        <div id="wrapper">
            <Sidebar menuCode={"HIST0300"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='이력 페이지 접속 기록'/>
                        <br/>
                        <Card className="card shadow mb-4">
                            {loading ? <Loading /> : null}
                            <Card.Header className="py-3">
                                <div className="form-group row">
                                    <Form className="search_area">
                                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko-KR">
                                            <DemoContainer components={['DatePicker', 'DatePicker']} sx={{marginLeft:'1rem'}}>
                                                <DatePicker
                                                    label="시작일자"
                                                    format='YYYY-MM-DD'
                                                    slotProps={{
                                                        textField:{
                                                            size:'small'
                                                        }
                                                    }}
                                                    value={startDate}
                                                    onChange={setStartDate}
                                                    defaultValue={dayjs()}
                                                    shouldDisableDate = {(day) => {
                                                        return day > endDate;
                                                    }}
                                                />
                                                <DatePicker
                                                    label="종료일자"
                                                    format='YYYY-MM-DD'
                                                    slotProps={{
                                                        textField:{
                                                            size:'small'
                                                        }
                                                    }}
                                                    value={endDate}
                                                    onChange={setEndDateChange}
                                                    slots={{ textField: TextField }}
                                                    disableFuture
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </Form>
                                    <div className='search_button_area' style={{paddingTop:'8px'}}>
                                        <Button variant="primary" className='search_button'
                                                onClick={handleHistorySubmit}>검색</Button>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div style={{display: 'flex', marginBottom:"1.5rem"}}>
                                    <p className='card-body_content' style={{display:"flex", alignItems:"center", margin:"0 10px 0 0"}}>총 데이터 : {totalData}건</p>
                                    <Form.Select className="select_box" id='search_select' value={listSelected}
                                                 onChange={handleChangeListSelect}>
                                        <option value="15">15개</option>
                                        <option value="30">30개</option>
                                        <option value="50">50개</option>
                                        <option value="100">100개</option>
                                    </Form.Select>
                                </div>
                                <TableContainer component={Paper}>
                                    <Table style={{marginBottom: 0}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="center">아이디</StyledTableCell>
                                                <StyledTableCell align="center">이름</StyledTableCell>
                                                <StyledTableCell align="center">ip</StyledTableCell>
                                                <StyledTableCell align="center">설명</StyledTableCell>
                                                <StyledTableCell align="center">이용일시</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.map(history => (
                                                <TableRow key={history.id} className="custom-link">
                                                    <StyledTableCell align="center">{history.userId || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{history.userName || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{history.ip || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{history.description || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{history.dtm.replace("T", " ") || "-"}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card.Body>
                        </Card>
                        <div>
                            <Pagination
                                totalPages={totalPages}
                                currentPage={currentPage}
                                onPageChange={handlePageChange}>
                            </Pagination>
                            <div style={{display: "flex", justifyContent: "center", marginBottom: '1rem'}}>
                                <Form.Control className="currentForm" value={textCurrentPage}
                                              onChange={(e) => setTextCurrentPage(e.target.value)}/>
                                <button className="btn btn-primary currentButton" onClick={handleCurrentPageText}>
                                    <span>이동</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    );
}

export default HistoryPageCallLog;